import { MailingBaseFormDto, falseWhenTypeNotIn, type MailingBaseFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-base-form.dto';
import { PlanningUnitFormDto, type PlanningUnitFormInterface } from '@zaoblako/shared/common/dtos/planning-unit/planning-unit-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';
import { MailingTypeEnum } from '@zaoblako/shared/modules/notification/enums/mailing.type.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';

/** Mailing template base create and update API form fields - DTO signature */
export interface MailingTemplateBaseFormInterface extends MailingBaseFormInterface {
  /** Mailing launch date */
  planning: PlanningUnitFormInterface;
  /**
   * Last months number to compute bills or documents dates period to take. Using only when
   * {@link MailingTemplateBaseFormInterface.type} property equals {@link MailingTypeEnum.BILLS}
   * or {@link MailingTypeEnum.DOCUMENTS}.
   */
  attachmentLastMonthsCount?: number;
}

/** Mailing template base create and update API form fields - DTO schema */
export const MailingTemplateBaseFormDto = SerdeDtoClass.from<MailingBaseFormInterface, MailingTemplateBaseFormInterface>(
  MailingBaseFormDto,
  NotificationDtoKeysEnum.MAILING_TEMPLATE_BASE_FORM_DTO,
  {
    planning: {
      label: 'Настройки планирования',
      nested: PlanningUnitFormDto,
      serializer: (_, nested) => nested,
    },
    attachmentLastMonthsCount: {
      optional: falseWhenTypeNotIn(MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS),
      hidden: falseWhenTypeNotIn(MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS),
      label: 'Последних месяцев',
      serializer: idLikeSchema,
    },
  },
);
